// Fetch Shopify-rendered cards so pricing, claims, stock and cart controls stay shared.
const queue = []
let active = 0

async function loadShelf(slot) {
  try {
    const url = new URL(slot.dataset.categoryShelfUrl, location.origin)
    url.searchParams.set('section_id', 'category-product-shelf')
    const preview = new URL(location.href).searchParams.get('preview_theme_id')
    if (preview && preview !== '0') url.searchParams.set('preview_theme_id', preview)
    const response = await fetch(url, { signal: AbortSignal.timeout(15000) })
    if (!response.ok) throw new Error('Shelf request failed')
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html')
    const content = doc.querySelector('[data-category-shelf-content]')
    if (!content?.querySelector('.tile')) return
    slot.replaceChildren(document.importNode(content, true))
    // Native type collections need their query parameter retained in See all.
    slot.querySelector('.shelf__all').href = slot.dataset.categoryShelfUrl
    slot.hidden = false
    document.dispatchEvent(new CustomEvent('opensku:shelves-added'))
    document.dispatchEvent(new CustomEvent('opensku:dom-added'))
  } catch {
    // Keep a working category link if the product preview cannot be loaded.
    const link = document.createElement('a')
    const url = new URL(slot.dataset.categoryShelfUrl, location.origin)
    link.href = url.href
    link.textContent = url.searchParams.get('q')
    link.className = 'shelf__all'
    slot.replaceChildren(link)
    slot.hidden = false
  }
}

function drain() {
  while (active < 3 && queue.length) {
    active++
    loadShelf(queue.shift()).finally(() => { active--; drain() })
  }
}

function bind() {
  for (const slot of document.querySelectorAll('[data-category-shelf-url]')) {
    if (slot.dataset.loading) continue
    slot.dataset.loading = 'true'
    queue.push(slot)
  }
  drain()
}
bind()
document.addEventListener('shopify:section:load', bind)
